// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, MenuItem, Select, FormControl, Chip } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SoftButton from "../../components/common/softButton";
import { toast } from "react-toastify";
import { deletePromotion, getPromotion } from "../../features/promotion";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import ActionMenu from "../../components/common/custom/action-menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { deleteRoleData, getRoleData } from "../../features/role";

const PERMISSION_SUMMARY_LIMIT = 10;

const PermissionPills = ({ permissions }: { permissions: any[] }) => {
  const list = (permissions || []).filter(Boolean);
  const visible = list.slice(0, PERMISSION_SUMMARY_LIMIT);
  const remaining = list.length - visible.length;

  if (list.length === 0) {
    return (
      <SoftTypography variant="caption" color="text">
        —
      </SoftTypography>
    );
  }

  return (
    <SoftBox
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "6px",
      }}
    >
      {visible.map((permission: any, index: number) => (
        <Chip
          key={permission?._id || index}
          label={permission?.name || "-"}
          variant="outlined"
          size="small"
          sx={{
            borderRadius: "6px",
            height: "24px",
            backgroundColor: "transparent",
            "& .MuiChip-label": {
              px: "10px",
              fontSize: "0.72rem",
              fontWeight: 500,
            },
          }}
        />
      ))}
      {remaining > 0 && (
        <Chip
          label={`+${remaining} more`}
          variant="outlined"
          size="small"
          sx={{
            borderRadius: "6px",
            height: "24px",
            backgroundColor: "transparent",
            "& .MuiChip-label": {
              px: "10px",
              fontSize: "0.72rem",
              fontWeight: 600,
            },
          }}
        />
      )}
    </SoftBox>
  );
};

const RolesManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: roles, status, pagination } = useSelector(
    (state: any) => state.roles
  );
  const [language, setLanguage] = useState("en");

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleDelete = (id: string) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Role?"
    );
    if (isConfirmed) {
      dispatch(deleteRoleData({ id }))
    }
  };


  const columns = [
    {
      header: "Name",
      accessorKey: "name",
      id: "name",
      align: "left",
      cell: (info: any) => (
        <strong style={{ whiteSpace: "nowrap" }}>{info.getValue()}</strong>
      ),
    },
    {
      header: "Permissions",
      id: "permissions",
      align: "left",
      cell: (info: any) => (
        <PermissionPills permissions={info.row.original.permissions} />
      ),
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original._id;
        return (
          <ActionMenu>
            <MenuItem onClick={() => navigate(`/role/edit/${id}`)}>
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleDelete(id); // // // console.log(id,'id');
              }}
            >
              Delete
            </MenuItem>
          </ActionMenu>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getRoleData({ page: pageIndex, limit: pageSize, lan: language }));
  }, [dispatch, pageIndex, pageSize, language, status]);

  useEffect(() => {
    if (status && roles) {
      setData(roles);
      setTotalRows(pagination?.total || roles?.length || 0);
    }
  }, [status, roles, pagination]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
                Roles Management
              </SoftTypography>

              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  width: "30%",
                }}
              >
                <FormControl
                  sx={{
                    marginRight: "10px",
                    minWidth: "160px",
                  }}
                  size="small"

                >
                  <Select
                    labelId="user-type-label"
                    id="language"
                    name="language"
                    value={language}
                    label="Language"
                    onChange={(e) => setLanguage(e.target.value)}
                    IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
                  >
                    <MenuItem value={"en"} sx={{ marginBottom: "5px" }}>
                      English
                    </MenuItem>
                    <MenuItem value={"ar"}>Arabic</MenuItem>
                  </Select>
                </FormControl>
                <SoftButton
                  onClick={() => navigate("/role/add")}
                  variant="contained"
                  color="final"
                  style={{ textTransform: "Capitalize" }}
                >
                  Add Role
                </SoftButton>
              </SoftBox>
            </SoftBox>
            <Table
              columns={columns}
              data={data}
              pageIndex={pageIndex}
              pageSize={pageSize}
              totalRows={totalRows}
              onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            />
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default RolesManagement;
